const RAMMAN_TAGS = {
  TRANSACTIONS: 'TRANSACTIONS',
  SALES_AND_PURCHASES: 'SALES_AND_PURCHASES',
} as const;

type RammanTag = (typeof RAMMAN_TAGS)[keyof typeof RAMMAN_TAGS];

const ALL_TAGS: RammanTag[] = [
  RAMMAN_TAGS.TRANSACTIONS,
  RAMMAN_TAGS.SALES_AND_PURCHASES,
] as const;

export { ALL_TAGS, RAMMAN_TAGS };
